import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery, applySpec, equals, flow, get, pipe, some} from '@yandex-delivery/utils'

import type {
  NddClaimOffersInfoRequest,
  NddClaimOffersRequest,
  NddClaimOffersResponse,
  NddClaimPolicy,
  NddClaimsOffer,
  NddClaimStationTagListResponse,
  NddClaimStationTagsListRequest,
} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

const toOffersInfoBody: (r: NddClaimOffersInfoRequest) => NddClaimOffersRequest = applySpec<NddClaimOffersRequest>({
  source: {
    platform_station_id: get('station_id'),
  },
  destination: {
    platform_station_id: get('self_pickup_id'),
    address: get('full_address'),
  },
  places: get('places'),
})

function fetchStationTags(stationIds: string): Promise<NddClaimStationTagListResponse> {
  return fetch<NddClaimStationTagsListRequest, NddClaimStationTagListResponse, NddClaimStationTagListResponse>({
    url: addQuery(externalApiURL('integration/v1/station/tag/list'), {
      country: appConfig.countryCode,
      ids: stationIds,
    }),
    method: 'GET',
  })
}

function fetchOffersInfo(body: NddClaimOffersRequest, query: NddClaimPolicy): Promise<NddClaimOffersResponse> {
  // return import('./fetch-ndd-delivery-intervals.json').then(r => r.default as unknown as NddClaimOffersResponse)
  return fetch<NddClaimOffersRequest, NddClaimOffersResponse, NddClaimOffersResponse>({
    url: addQuery(externalApiURL('platform/integration/v1/offers/info'), {...query, country: appConfig.countryCode}),
    method: 'POST',
    body,
  })
}

export async function fetchNddDeliveryIntervalsDeprecated(query: NddClaimOffersInfoRequest): Promise<NddClaimsOffer> {
  const stationInfo = await fetchStationTags(query.station_id)
  const isExpressLastMilePolicy = pipe(
    stationInfo,
    get('objects[0].tags'),
    some(flow(get('tag_name'), equals('abstract_supply_promise_taxi-external_reservation'))),
  )

  const policy: NddClaimPolicy = {
    last_mile_policy: isExpressLastMilePolicy ? 'express' : '',
  }
  const offers = await fetchOffersInfo(toOffersInfoBody(query), policy).then(response => {
    const respOffers = response.offers || []

    if (respOffers.length === 0) {
      throw new Error('No offers found')
    }

    return respOffers
  })

  return {
    offers,
    policy,
  }
}
